import { Controller } from "@hotwired/stimulus";
import {FetchRequest} from "@rails/request.js";

// Connects to data-controller="specific--int-nennung"
export default class extends Controller {
  static targets = ["feiEventDropdown", "slotCheckbox", "pferdeField", "zusaetzlicheFelderFrame", "form"];
  static values = {
    nennungUpdateUrl: String,
    isSlotAktiv: Boolean,
    validateUrl: String,
  }

  connect() {
    if (this.isSlotAktivValue) {
      this.#togglePferdeFields()
    }
  }

  slotCheckboxTargetConnected(toggle) {
    toggle.checked = this.isSlotAktivValue;
  }

  clickedSlotCheckbox() {
    this.isSlotAktivValue = this.slotCheckboxTarget.checked;
    this.#togglePferdeFields();
  }

  updatePferdFrame() {
    const url = new URL(this.nennungUpdateUrlValue);
    url.searchParams.set("fei_event_code", this.feiEventDropdownTarget.value);
    window.history.replaceState(history.state, "", url)

    url.searchParams.set("temp_id", this.zusaetzlicheFelderFrameTarget.dataset.tempId);
    Turbo.visit(url, { frame: this.zusaetzlicheFelderFrameTarget.id });
  }

  async validateEvents() {
    const url = new URL(this.validateUrlValue);
    const responseKind = this.element.dataset.responseKind || "turbo-stream";
    const form = this.hasFormTarget ? this.formTarget : document.getElementById("internationale-nennung-form");
    const body = new FormData(form);

    const request = new FetchRequest("POST", url, { body, responseKind });
    await request.perform();
  }

  #togglePferdeFields() {
    this.pferdeFieldTargets.forEach((pferdeField) => {
      pferdeField.classList.toggle("d-none");
    });
  }
}
